import { render, staticRenderFns } from "./health-record-view-popup.html?vue&type=template&id=46e2c739&scoped=true&external"
import script from "./health-record-view-popup.js?vue&type=script&lang=js&external"
export * from "./health-record-view-popup.js?vue&type=script&lang=js&external"
import style0 from "./health-record-view-popup.scss?vue&type=style&index=0&id=46e2c739&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e2c739",
  null
  
)

export default component.exports